import { NgModule } from '@angular/core';
import { ArticleComponent } from './article.component';
import { ArticleRoutingModule } from './article.routing.module';
import { SharedModel } from '../../shared/shared.module';
import { CardModule } from 'primeng/card';
import { CommonModule } from '@angular/common';
import { ArticlesService } from '../../services/articles.service';
@NgModule({
  declarations: [ArticleComponent],
  imports: [
    ArticleRoutingModule,
    SharedModel,
    CardModule,
    CommonModule
  ],
  providers: [ ArticlesService ]
})
export class ArticleModule { }
